module.exports = __webpack_public_path__ + "img/plusfl_3.5cada8d5.png";